import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface addSpotlightInterface {
  vid: string;
}

export const useAddSpotlightVideos = () => {
  const mutate = useMutation(({ vid }: addSpotlightInterface) => {
    return get(`/enterprise-media-api/add_spotlight_videos/${vid}`);
  });

  return mutate;
};

export default useAddSpotlightVideos;
